import React, { useMemo } from 'react';
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  TextField,
  Tooltip,
  TableContainer,
  Tab,
  Paper,
  Divider
} from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { useSelector } from 'react-redux';
import SrchProd from 'src/components/SrchProd';
import qtyPCToCS from 'src/helpers/qtyPCtoCS';

const SectionTable = ({
  title,
  rows = [],
  getName,
  getCode,
  getProduct,
  onDelete,
  onAddRow,
  onUpdateRow
}) => {
  return (
    <Box>
      <Typography
        variant="subtitle1"
        color="primary"
        style={{ fontWeight: 600 }}
        gutterBottom
      >
        {title}
      </Typography>
      <Divider />

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell style={{ width: 40 }}>#</TableCell>
            <TableCell style={{ width: 90 }}>Product Code</TableCell>
            <TableCell>Product Name</TableCell>
            <TableCell align="right" style={{ width: 100 }}>
              Input Qty
            </TableCell>
            <TableCell align="right" style={{ width: 100 }}>
              PC
            </TableCell>
            <TableCell align="right" style={{ width: 100 }}>
              SC
            </TableCell>
            <TableCell align="right" style={{ width: 100 }}>
              CS
            </TableCell>
            <TableCell align="right" style={{ width: 25 }}>
              Action
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((p, idx) => {
            const prod = getProduct ? getProduct(p.ixProd) : null;
            const libQtyCS = prod?.libQtyCS ?? prod?.qtyCS ?? 0;
            const libQtySC = prod?.libQtySC ?? prod?.qtySC ?? 0;

            const invBreakdown = qtyPCToCS({
              libQtyCS,
              libQtySC,
              qty: Number(p.invQty) || 0,
              keyProp: 'inv'
            });

            console.log('invBreakdown', invBreakdown);

            return (
              <TableRow key={`${title}_${p.ixProd}_${idx}`}>
                <TableCell>{idx + 1}</TableCell>
                <TableCell>{getCode ? getCode(p.ixProd) : p.ixProd}</TableCell>
                <TableCell>{getName(p.ixProd)}</TableCell>

                {/* Editable deal Qty */}
                <TableCell align="right">
                  <TextField
                    value={p.invQty}
                    // type="number"
                    size="small"
                    margin="dense"
                    variant="outlined"
                    onChange={e => {
                      const val = Number(e.target.value);
                      const nextQty = isNaN(val) ? 0 : val;
                      onUpdateRow(idx, { ...p, invQty: nextQty });
                    }}
                    inputProps={{
                      style: { textAlign: 'right', width: 100, min: 0 }
                    }}
                  />
                </TableCell>

                {/* <TableCell align="right">
                  <TextField
                    value={Number(p.invQty) === 0 ? '' : p.invQty}
                    // type="number"
                    size="small"
                    margin="dense"
                    variant="outlined"
                    onChange={e => {
                      const val = Number(e.target.value);
                      onUpdateRow(idx, { ...p, invQty: isNaN(val) ? 0 : val });
                    }}
                    inputProps={{
                      style: { textAlign: 'right', width: 100, min: 0 }
                    }}
                  />
                </TableCell> */}

                <TableCell align="right">
                  <TextField
                    value={invBreakdown.inv_PC === 0 ? '' : invBreakdown.inv_PC}
                    // type="number"
                    size="small"
                    margin="dense"
                    variant="outlined"
                    disabled={true}
                    InputProps={{ readOnly: true }}
                    inputProps={{
                      style: { textAlign: 'right', width: 100, min: 0 }
                    }}
                  />
                </TableCell>

                <TableCell align="right">
                  <TextField
                    value={invBreakdown.inv_SC === 0 ? '' : invBreakdown.inv_SC}
                    // type="number"
                    size="small"
                    margin="dense"
                    variant="outlined"
                    disabled={true}
                    InputProps={{ readOnly: true }}
                    inputProps={{
                      style: { textAlign: 'right', width: 100, min: 0 }
                    }}
                  />
                </TableCell>

                <TableCell align="right">
                  <TextField
                    value={invBreakdown.inv_CS === 0 ? '' : invBreakdown.inv_CS}
                    // type="number"
                    size="small"
                    margin="dense"
                    variant="outlined"
                    disabled={true}
                    InputProps={{ readOnly: true }}
                    inputProps={{
                      style: { textAlign: 'right', width: 100, min: 0 }
                    }}
                  />
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="Remove" arrow>
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => onDelete(idx)}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            );
          })}

          {/* Add Row */}
          <TableRow>
            <TableCell colSpan={8} padding="none">
              <SrchProd
                sProd=""
                ixProd={0}
                handleProdSelectRoot={item => onAddRow(item)}
                textBoxProps={{
                  label: `Add to ${title}`,
                  placeholder: 'Search product...',
                  fullWidth: true,
                  size: 'small',
                  margin: 'dense'
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

const AddedProducts = ({ value, onChange }) => {
  const allProducts = useSelector(state => state.storedValues?.products || []);

  const parsed = useMemo(() => {
    try {
      const raw =
        typeof value === 'string' ? JSON.parse(value || '{}') : value || {};
      return {
        product: Array.isArray(raw?.product) ? raw.product : [],
        free_products: Array.isArray(raw?.free_products)
          ? raw.free_products
          : []
      };
    } catch {
      return { product: [], free_products: [] };
    }
  }, [value]);

  const getName = ixProd =>
    allProducts.find(p => p.ixProd === ixProd)?.sProd || '';

  const getCode = ixProd =>
    allProducts.find(p => p.ixProd === ixProd)?.ProdCd || '';

  const getProduct = ixProd =>
    allProducts.find(p => p.ixProd === ixProd) || null;

  const updateJson = next =>
    onChange && onChange(JSON.stringify(next, null, 2));

  const addToSection = (item, section) => {
    if (!item) return;
    const ix = item.ixProd;

    // const exists =
    //   parsed.product.some(p => p.ixProd === ix) ||
    //   parsed.free_products.some(p => p.ixProd === ix);
    // if (exists) return alert('Product already added in tables.');

    const next = {
      product: [...parsed.product],
      free_products: [...parsed.free_products]
    };
    next[section].push({
      ixProd: ix,
      invQty: 0
    });
    updateJson(next);
  };

  const deleteAt = (section, idx) =>
    updateJson({
      product:
        section === 'product'
          ? parsed.product.filter((_, i) => i !== idx)
          : parsed.product,
      free_products:
        section === 'free_products'
          ? parsed.free_products.filter((_, i) => i !== idx)
          : parsed.free_products
    });

  const updateRow = (section, idx, updated) => {
    const next = {
      product: [...parsed.product],
      free_products: [...parsed.free_products]
    };
    next[section][idx] = updated;
    updateJson(next);
  };

  return (
    <Box display="flex" flexDirection="column" width="100%" gridGap={16}>
      <TableContainer
        component={Paper}
        style={{ marginBottom: 5, padding: 10, margin: '0 auto' }}
      >
        <SectionTable
          title="Main Product"
          rows={parsed.product}
          getName={getName}
          getCode={getCode}
          getProduct={getProduct}
          onDelete={idx => deleteAt('product', idx)}
          onAddRow={item => addToSection(item, 'product')}
          onUpdateRow={(idx, updated) => updateRow('product', idx, updated)}
        />
      </TableContainer>

      <TableContainer
        component={Paper}
        style={{ marginBottom: 5, padding: 10, margin: '0 auto' }}
      >
        <SectionTable
          title="Free Product"
          rows={parsed.free_products}
          getName={getName}
          getCode={getCode}
          getProduct={getProduct}
          onDelete={idx => deleteAt('free_products', idx)}
          onAddRow={item => addToSection(item, 'free_products')}
          onUpdateRow={(idx, updated) =>
            updateRow('free_products', idx, updated)
          }
        />
      </TableContainer>
    </Box>
  );
};

export default AddedProducts;
